export default __webpack_public_path__ + "static/media/button_hover.74e153d1.mp3";